import { type EdgeProps } from '@xyflow/react';

import { colors } from 'common';

import { NotableEdge } from './Edge';

export function ErrorEdge(props: EdgeProps) {
  return (
    <NotableEdge
      {...props}
      style={{
        stroke: colors.extended.red[80],
        strokeDasharray: '6 4',
        ...props.style,
      }}
    />
  );
}
